import {Injectable} from "@angular/core";
import {Observable} from "rxjs";
import {AddMultipleFormatsToCartModel} from "../../models/cart/add-multiple-formats-to-cart.model";
import {AddSingleFormatToCartModel} from "../../models/cart/add-single-format-to-cart.model";
import {AddToCartFormatModel} from "../../models/cart/add-to-cart-format.model";
import {AddToCartResultModel} from "../../models/cart/add-to-cart-result.model";
import {PriceCalculationResultModel} from "../../models/cart/price-calculation-result.model";
import {ApiResultDispatcherService} from "../api/api-result-dispatcher.service";
import {ApiService} from "../api/api-service";

@Injectable({
    providedIn: "root"
})
export class ProductCartService {
    private API_BASE_URL = "/nop";

    private API_PRODUCT_TO_CART = `${this.API_BASE_URL}/quickShop/addToCart`;
    private API_CALCULATE_PRODUCT_PRICE = `${this.API_BASE_URL}/quickShop/calculatePrice`;

    public constructor(
        private apiService: ApiService,
        private apiDispatcherService: ApiResultDispatcherService
    ) {
    }

    public calculatePriceBySingleFormat(singleFormatModel: AddSingleFormatToCartModel): Observable<PriceCalculationResultModel> {
        const multipleFormatsModel = this.mapToMultipleFormatsModel(singleFormatModel);
        return this.calculatePriceByMultipleFormats(multipleFormatsModel);
    }

    public calculatePriceByMultipleFormats(model: AddMultipleFormatsToCartModel): Observable<PriceCalculationResultModel> {
        const http = this.apiService.executePost<PriceCalculationResultModel>(
            this.API_CALCULATE_PRODUCT_PRICE,
            model
        );

        const result = this.apiDispatcherService.dispatchErrorsAndUnwrapResult(http);

        return result;
    }

    public addSingleFormatToCart(singleFormatModel: AddSingleFormatToCartModel): Observable<AddToCartResultModel> {
        const multipleFormatsModel = this.mapToMultipleFormatsModel(singleFormatModel);
        return this.addMultipleFormatsToCart(multipleFormatsModel);
    }

    public addMultipleFormatsToCart(multipleFormatsModel: AddMultipleFormatsToCartModel): Observable<AddToCartResultModel> {
        return this.addMultipleFormatsListToCart([multipleFormatsModel]);
    }

    public addSingleFormatsListToCart(singleFormatListModel: Array<AddSingleFormatToCartModel>): Observable<AddToCartResultModel> {
        return this.addMultipleFormatsListToCart(singleFormatListModel.map(x => this.mapToMultipleFormatsModel(x)));
    }

    public addMultipleFormatsListToCart(multipleFormatsListModel: Array<AddMultipleFormatsToCartModel>): Observable<AddToCartResultModel> {
        const http = this.apiService.executePost<AddToCartResultModel>(
            this.API_PRODUCT_TO_CART,
            multipleFormatsListModel
        );

        const result = this.apiDispatcherService.dispatchErrorsAndUnwrapResult(http);

        return result;
    }

    public mapToMultipleFormatsModel(formModel: AddSingleFormatToCartModel): AddMultipleFormatsToCartModel {
        const cartModel = new AddMultipleFormatsToCartModel(formModel.productId);
        cartModel.formats.push(new AddToCartFormatModel(formModel.format, formModel.quantity));

        return cartModel;
    }
}
